import { LuTriangleAlert } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import EquipmentSelectionList from './equipment-selection-list/equipment-selection-list.component';
import useLendingPickByState, { type LendingPickByStateSetupError } from './lending-pick-by-state.controller';

const ID = 'lending-pick-by-state';
export interface LendingPickByStateProps {}

const LendingPickByState = (props: LendingPickByStateProps) => {
    const viewProps = useLendingPickByState(props);

    if (!viewProps.setupError) {
        return (
            <EquipmentSelectionList
                onBack={viewProps.onBack}
                onSubmit={viewProps.onSubmit}
                isSubmitting={viewProps.processing}
            />
        );
    }

    return (
        <WizardScreenContainer
            id={ID}
            header={{ onBack: viewProps.onBack }}
            footer={{
                onBack: viewProps.onBack
            }}>
            <MaintenanceSetupError error={viewProps.setupError} />
        </WizardScreenContainer>
    );
};

const MaintenanceSetupError = (props: { error: LendingPickByStateSetupError }) => (
    <div className='flex size-full items-center justify-center p-6'>
        <div className='bg-background-surface inline-flex w-full flex-col items-center justify-start gap-4 rounded-xl p-6 text-center'>
            <div className='bg-status-danger flex size-10 items-center justify-center rounded-full'>
                <LuTriangleAlert className='text-background-surface size-6' />
            </div>
            <div className='flex flex-col gap-1'>
                <div className='text-foreground-default text-base font-semibold'>
                    <FormattedMessage
                        id='manage-spot.lending-equipments.setup-error.title'
                        defaultMessage='Could not open SLOTs'
                    />
                </div>
                <div className='text-brand-muted text-sm font-medium'>
                    {props.error === 'missing_configuration' ? (
                        <FormattedMessage
                            id='manage-spot.lending-equipments.setup-error.missing-configuration'
                            defaultMessage='This distriSPOT is missing the maintenance workflow configuration.'
                        />
                    ) : (
                        <FormattedMessage
                            id='manage-spot.lending-equipments.setup-error.failed'
                            defaultMessage='Something went wrong while preparing the maintenance transaction.'
                        />
                    )}
                </div>
            </div>
        </div>
    </div>
);

export default LendingPickByState;
